(function () {
  const footer = document.querySelector('[data-section-type="footer"]');
  if (!footer) return;

  const backToTop = footer.querySelector('[data-back-to-top]');
  if (backToTop) {
    let ticking = false;

    const updateBackToTop = () => {
      backToTop.classList.toggle('show', window.scrollY > 600);
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateBackToTop);
      },
      { passive: true }
    );

    updateBackToTop();

    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  const disclosures = footer.querySelectorAll('.disclosure');
  if (!disclosures.length) return;

  /** @param {Element | null | undefined} [exceptThisOne] */
  const closeAllDisclosures = (exceptThisOne) => {
    disclosures.forEach((wrapper) => {
      if (wrapper === exceptThisOne) return;

      const list = wrapper.querySelector('[data-disclosure-list]');
      const btn = wrapper.querySelector('[data-disclosure-toggle]');

      if (list) list.classList.remove('disclosure-list--visible');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };

  disclosures.forEach((disclosure) => {
    const toggleButton = disclosure.querySelector('[data-disclosure-toggle]');
    const list = disclosure.querySelector('[data-disclosure-list]');
    const input = disclosure.querySelector('[data-disclosure-input]');
    const options = disclosure.querySelectorAll('[data-disclosure-option]');

    if (!toggleButton || !list || !(input instanceof HTMLInputElement)) return;

    toggleButton.addEventListener('click', () => {
      closeAllDisclosures(disclosure);
      const isVisible = list.classList.toggle('disclosure-list--visible');
      toggleButton.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
    });

    options.forEach((option) => {
      option.addEventListener('click', (event) => {
        event.preventDefault();
        const value = option.getAttribute('data-value');
        if (!value) return;
        input.value = value;
        disclosure.closest('form')?.submit();
      });
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest('[data-section-type="footer"] .disclosure')) {
      closeAllDisclosures();
    }
  });
})();
